module.exports = __webpack_public_path__ + "img/bg-fundanow-cash-02.6fb1a73f.svg";